function AxeCoreReactPlugin() {
    return {
        name: 'axe-core-react',
        onBrowserInit: function (context, next) {
            if (process.env.NODE_ENV !== 'production') {
                var axe = require('@axe-core/react');
                var React_1 = require('react');
                var ReactDOM_1 = require('react-dom');
                axe(React_1, ReactDOM_1, 1000); // eslint-disable-line no-magic-numbers
            }
            return next(context);
        },
    };
}

export { AxeCoreReactPlugin as default };
//# sourceMappingURL=browser.js.map
